/**
 * Centralized Cognito configuration
 * This file provides a single source of truth for Cognito configuration
 * and ensures that the correct values are used throughout the application
 */

// Get configuration from environment variables
export const cognitoConfig = {
  UserPoolId: process.env.REACT_APP_USERPOOLID,
  ClientId: process.env.REACT_APP_USERPOOLCLIENTID,
  Region: process.env.REACT_APP_USERPOOLID ? process.env.REACT_APP_USERPOOLID.split('_')[0] : 'ap-southeast-2',
  Domain: process.env.REACT_APP_USERPOOL_DOMAIN || `dozzy-${process.env.AWS_ACCOUNT_ID || '927626568595'}-dev`,
};

// Log the configuration for debugging
console.log('Cognito Config:', {
  UserPoolId: cognitoConfig.UserPoolId,
  ClientId: cognitoConfig.ClientId,
  Region: cognitoConfig.Region,
  Domain: cognitoConfig.Domain
});

// Validate configuration
export const validateCognitoConfig = () => {
  const errors = [];
  
  if (!cognitoConfig.UserPoolId) {
    errors.push('Missing User Pool ID (REACT_APP_USERPOOLID)');
  }
  
  if (!cognitoConfig.ClientId) {
    errors.push('Missing Client ID (REACT_APP_USERPOOLCLIENTID)');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Export the validation result for immediate use
export const configValidation = validateCognitoConfig();
if (!configValidation.isValid) {
  console.error('Cognito configuration is invalid:', configValidation.errors);
}

export default cognitoConfig;
